<app-inner-box>

  <nz-breadcrumb>
    <nz-breadcrumb-item>
      <a routerLink="/">
        <i nz-icon nzType="home"></i>
      </a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>
      <a [routerLink]="parentLink">{{ parentTitle }}</a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>
      {{ articleName }}
    </nz-breadcrumb-item>
  </nz-breadcrumb>

  <div class="header d-flex align-items-center">
    <h1 style="margin-bottom: 0; margin-right: 12px;">{{title}}</h1>
    <div class="actions">
      <app-add-edit-article-modal #modal (refresh)="loadContent()">
        <span trigger>
          <app-icon-button
            icon="edit"
            [ariaLabel]="'Großgebinde bearbeiten: ' + title"
            (pressed)="modal.showModal($any({ id: this.shopwareArticleId$.getValue(), name: articleName }))"
          ></app-icon-button>
        </span>
      </app-add-edit-article-modal>
    </div>
  </div>

  <nz-divider></nz-divider>

  @if (bulkContainer$|async; as bulkContainer) {
    <nz-row [nzGutter]="16" nzJustify="center">
      <nz-col [nzSpan]="10">
        <nz-row [nzGutter]="50">
          <nz-col>
            <nz-statistic
              [nzValue]="bulkContainer.bulkContainerState | productionUnit:true"
              [nzTitle]="'Aktueller Stand'"
            ></nz-statistic>
          </nz-col>
          <nz-col>
            <nz-statistic
              [nzValue]="bulkContainer.difference | productionUnit:true"
              [nzTitle]="'In Produktion'"
            ></nz-statistic>
          </nz-col>
          <nz-col>
            <div class="ant-statistic">
              <div class="ant-statistic-title">Baobab aus eigener Produktion: </div>
              <div class="ant-statistic-content">
                <span class="ant-statistic-content-value">
                  {{ bulkContainer.productionArticle?.isOwnProduction | booleanFormat }}
                </span>
              </div>
            </div>
          </nz-col>
          <nz-col>
            <div class="ant-statistic">
              <div class="ant-statistic-title">Bio </div>
              <div class="ant-statistic-content">
                <span class="ant-statistic-content-value">{{ bulkContainer.productionArticle?.isBio | booleanFormat }}</span>
              </div>
            </div>
          </nz-col>
        </nz-row>
      </nz-col>
      <nz-col [nzSpan]="8">
        @if (bulkContainer.orderQuantitySum === null) {
          <h2>Keine weitere Lieferung geplant</h2>
        }
        @if (bulkContainer.orderQuantitySum !== null) {
          <h2>Nächste Lieferung</h2>
          <nz-divider></nz-divider>
          <nz-row [nzGutter]="50">
            <nz-col>
              <div class="ant-statistic">
                <div class="ant-statistic-title">Bestelltermin</div>
                <div class="ant-statistic-content">
                  <span class="ant-statistic-content-value">{{bulkContainer.orderDate|dateFormat}}</span>
                </div>
              </div>
            </nz-col>
            <nz-col><nz-statistic [nzValue]="(bulkContainer.orderSupplier?.name ?? '')" [nzTitle]="'Lieferant'"></nz-statistic></nz-col>
            <nz-col><nz-statistic [nzValue]="bulkContainer.orderQuantitySum | productionUnit:true" [nzTitle]="'Menge'"></nz-statistic></nz-col>
          </nz-row>
        }
      </nz-col>
      <nz-col [nzSpan]="6">
        <h2>Kommentar</h2>
        <nz-divider></nz-divider>
        <nz-row [nzGutter]="50">
          <nz-col [nzSpan]="24">
            <div class="ant-statistic">
              <div class="ant-statistic-title">letzter Kommentar</div>
              <div class="ant-statistic-content">
                <div class="comment">
                  {{ bulkContainer.articleComment?.comment ?? '-' }}
                </div>
                <br>
                  <button nz-button nzType="primary" (click)="showCommentControl = !showCommentControl">
                    Neuer Kommentar
                  </button>
                  @if (showCommentControl) {
                    <textarea nz-input style="margin: 8px 0; height: 150px;" [(ngModel)]="newComment"></textarea>
                    <div class="d-flex justify-content-end">
                      <button nz-button nzType="default" (click)="saveComment()">
                        Neuer Kommentar speichern
                      </button>
                    </div>
                  }
                </div>
              </div>
            </nz-col>
          </nz-row>
        </nz-col>
      </nz-row>
      <nz-row>
        <nz-col [nzSpan]="6">
          <div class="ant-statistic">
            <div class="ant-statistic-title">
              Mindestlagerbestand festgelegt
            </div>
            <div class="ant-statistic-content">
              <div class="d-flex align-items-center">
                <input type="number" nz-input [(ngModel)]="bulkContainer.minStock">&nbsp;kg
                <button
                  nz-button
                  nzType="primary"
                  nzShape="circle"
                  style="margin-left: 16px;"
                  (click)="updateMinStock(bulkContainer.minStock)"
                  >
                  <span
                    nz-icon
                    nzType="check"
                    nz-tooltip
                    nzTooltipTitle="Mindestbestand aktualisieren"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </nz-col>
      </nz-row>
    } @else {
      <nz-row [nzGutter]="16" nzJustify="center">
        <nz-col [nzXs]="24" [nzSm]="2">
          <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
        </nz-col>
      </nz-row>
    }

    <div class="card-container">
      <nz-tabs nzType="card" nzLinkRouter>
        <nz-tab (nzSelect)="true">
          <a *nzTabLink nz-tab-link
            [routerLink]="['.']"
            [queryParams]="{ tab: 'deliveries' }"
            queryParamsHandling="merge">
            Lieferungen
          </a>
          <app-deliveries-list
            [articleId]="articleId$ | async"
            (deliveryCreated)="loadContent()"
            (deliveryEdited)="loadContent()"
            (deliveryCancelled)="loadContent()"
            (changeLogCreated)="changeLogListComponent.onRefreshList(true); ownProductionChangeLogList?.onRefreshList(true); loadContent();"
          ></app-deliveries-list>
        </nz-tab>
        <nz-tab  >
          <a *nzTabLink nz-tab-link
            [routerLink]="['.']"
            [queryParams]="{ tab: 'production-orders' }"
            queryParamsHandling="merge">
            Produktionsaufträge (alt)
          </a>
          <app-list-for-article [articleId]="shopwareArticleId$|async"></app-list-for-article>
        </nz-tab>
        <nz-tab >
          <a *nzTabLink nz-tab-link
            [routerLink]="['.']"
            [queryParams]="{ tab: 'in-own-production' }"
            queryParamsHandling="merge">
            Warenausgang Eigenproduktion (alt)
          </a>
          <app-own-productions-list [articleId]="shopwareArticleId$|async"></app-own-productions-list>
        </nz-tab>
        <nz-tab >
          <a *nzTabLink nz-tab-link
            [routerLink]="['.']"
            [queryParams]="{ tab: 'warenausgang' }"
            queryParamsHandling="merge">
            Warenausgang Eigenproduktion
          </a>
          <app-change-log-list
            [articleId]="articleId$|async"
            [ownProductionOutflow]="true"
            #ownProductionChangeLogList>
          </app-change-log-list>
        </nz-tab>
        <nz-tab >
          <a *nzTabLink nz-tab-link
            [routerLink]="['.']"
            [queryParams]="{ tab: 'change-log' }"
            queryParamsHandling="merge">
            Inventurkorrektur
          </a>
          <app-change-log-list [articleId]="articleId$|async" #changeLogListComponent></app-change-log-list>
        </nz-tab>
        <nz-tab >
          <a *nzTabLink nz-tab-link
            [routerLink]="['.']"
            [queryParams]="{ tab: 'stock-stores' }"
            queryParamsHandling="merge">
            Lagerbestände
          </a>
          <app-article-variants-stores-stocks
            style="width: 100%"
            [articleId]="shopwareArticleId$|async"
          ></app-article-variants-stores-stocks>
        </nz-tab>

        <nz-tab>
          <a *nzTabLink nz-tab-link
            [routerLink]="['.']"
            [queryParams]="{ tab: 'comments' }"
            queryParamsHandling="merge">
            Kommentarverlauf
          </a>
          <app-comments-list
            #commentsListComponent
            style="width: 100%"
            [articleId]="articleId$|async"
            (refreshArticle)="loadContent()"
          ></app-comments-list>
        </nz-tab>
      </nz-tabs>
    </div>

  </app-inner-box>
